import type { RequirementKind } from "@wags/matchmaker/pure.ts";
import type { ContactMessageIntent } from "@wags/profile-contracts/contact-session.contract.ts";
import type { PostHogInterface } from "posthog-js";
import type { ContactFunnelProperties } from "@/features/provider-outreach";
import type { AttemptEvidence } from "./handoff-observation.contract";

type ReachOutReviewInput = ContactFunnelProperties & {
    listingId: string;
    requirementKinds: RequirementKind[];
};

export function captureReachOutReviewShown(
    posthog: PostHogInterface,
    input: ReachOutReviewInput,
) {
    posthog.capture("reach_out_review_shown", input);
}

export function captureReachOutAction(
    posthog: PostHogInterface,
    input: ReachOutReviewInput & {
        action: "copy_message" | "open_messages";
        intent: ContactMessageIntent;
    } & Partial<AttemptEvidence & { session_state: "unresolved" }>,
) {
    try {
        posthog.capture("reach_out_message_action", input);
    } catch {}
}
